(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["cart-template"]) return;
  try {
    
	jQuery('.bundle_properties').each(function(){
      var $this = $(this);
      $this.html(jQuery.parseHTML($this.html())[0].textContent);
  });

  } catch(e) { console.error(e); }
})();

})();
